// src/components/WinnersList.jsx
// src/components/WinnersList.js
import React, { useState, useEffect, useContext } from 'react';
import { WalletContext } from '../contexts/WalletContext';
import { ContractContext } from '../contexts/ContractContext';

const WinnersList = ({ poolId, poolName, onClose }) => {
  const [winners, setWinners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { account } = useContext(WalletContext);
  const { getPoolWinners } = useContext(ContractContext);

  // Format address helper
  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };

  useEffect(() => {
    const fetchWinners = async () => {
      try {
        const winnersData = await getPoolWinners(poolId);
        setWinners(winnersData);
      } catch (err) {
        console.error('Error loading winners:', err);
        setError('Could not load winners: ' + err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchWinners();
  }, [poolId, getPoolWinners]);

  return (
    <div className="winners-modal">
      <div className="winners-modal-content">
        <h3>Winners of {poolName}</h3>
        
        {isLoading ? (
          <div className="loading-container">
            <div className="loading"></div>
            <p>Loading winners...</p>
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : winners.length === 0 ? (
          <p>No winners found for this pool.</p>
        ) : (
          <table className="winners-table">
            <thead>
              <tr>
                <th>Position</th>
                <th>Address</th>
                <th>Prize</th>
              </tr>
            </thead>
            <tbody>
              {winners.map((winner, index) => (
                <tr 
                  key={index}
                  className={winner.isCurrentUser ? 'winner-you' : ''}
                >
                  <td>#{index + 1}</td>
                  <td>
                    {winner.isCurrentUser ? (
                      <span className="user-highlight">
                        {formatAddress(winner.address)} (YOU)
                      </span>
                    ) : (
                      formatAddress(winner.address)
                    )}
                  </td>
                  <td>{winner.prize} MONAD</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        
        <button className="close-modal" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default WinnersList;